import React from "react";
import "../static/css/dateTimePicker.scss";
import "../scss/styles.scss";
import { Provider } from "react-redux";
import { compose } from "redux";
import App, { Container } from "next/app";
import withRedux from "next-redux-wrapper";
import { initializeStore } from "../redux/store";
import Auth from "../lib/Auth";
import restConnector from "../lib/RestConnector";
import { loginSuccess, loadingDone } from "../redux/authActions";
import nprogress from "../components/nprogress";
import config from "react-reveal/globals";

config({ ssrFadeout: true });

global.self = global;
class AdminApp extends App {
  constructor(props) {
    super(props);
    this.state = {
      loading: true
    };
  }

  static async getInitialProps({ Component, ctx }) {
    const pageProps = Component.getInitialProps
      ? await Component.getInitialProps(ctx)
      : {};
    return { pageProps, isForAdmin: ctx.pathname !== "/" };
  }

  async componentDidMount() {
    if (this.props.isForAdmin) {
      restConnector.accessToken = localStorage.getItem("token");
      try {
        const user = await Auth.getCurrentUser();
        this.props.store.dispatch(loginSuccess(user));
      } catch (e) {
        this.props.store.dispatch(loadingDone);
      }
    }
    this.setState({ loading: false });
  }

  render() {
    const { Component, pageProps, store } = this.props;

    if (this.props.isForAdmin) {
      return (
        <Container>
          <Provider store={store}>
            <Component {...pageProps} />
          </Provider>
        </Container>
      );
    }
    return (
      <Container>
        <Component {...pageProps} />
      </Container>
    );
  }
}

/**
 * @param {object} initialState
 * @param {boolean} options.isServer indicates whether it is a server side or client side
 * @param {Request} options.req NodeJS Request object (if any)
 * @param {boolean} options.debug User-defined debug mode param
 * @param {string} options.storeKey This key will be used to preserve store in global namespace for safe HMR
 */
const makeStore = (initialState, options) => {
  return initializeStore(initialState, options);
};

export default compose(
  nprogress(300, { showSpinner: true }),
  withRedux(makeStore)
)(AdminApp);



// WEBPACK FOOTER //
// client/pages/_app.js